import React, { useEffect, useState } from 'react';
import api from '../services/api';
import ProductCard from '../components/product/ProductCard';

export default function SalePage() {
  const [products, setProducts] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api.get('/products', { params: { sort: 'discount', per_page: 24 } })
      .then(r => setProducts((r.data.data || r.data).filter((p: any) => p.compare_price && Number(p.compare_price) > Number(p.price))))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <div className="bg-red-700 py-16 text-center">
        <p className="text-xs font-medium uppercase tracking-[0.3em] text-red-200 mb-3">Limited Time</p>
        <h1 className="text-4xl md:text-5xl font-serif font-bold text-white">Special Prices</h1>
        <p className="text-red-100 mt-3 text-sm">Exclusive deals — while stocks last</p>
      </div>

      <div className="max-w-7xl mx-auto px-4 py-12">
        {loading ? (
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
            {Array(12).fill(null).map((_, i) => <div key={i} className="aspect-[3/4] bg-gray-100 animate-pulse rounded" />)}
          </div>
        ) : products.length === 0 ? (
          <div className="text-center py-20 text-gray-400">No sale items at the moment. Check back soon!</div>
        ) : (
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
            {products.map(p => <ProductCard key={p.id} product={p} />)}
          </div>
        )}
      </div>
    </div>
  );
}
